export const TOUR_PROPERTY_LIST_ACTION = "TOUR_PROPERTY_LIST_ACTION";
export const TOUR_PROPERTY_LIST_SUCCESS = "TOUR_PROPERTY_LIST_SUCCESS";
export const TOUR_PROPERTY_LIST_ALL_ACTION = "TOUR_PROPERTY_LIST_ALL_ACTION";
export const TOUR_PROPERTY_LIST_ALL_SUCCESS = "TOUR_PROPERTY_LIST_ALL_SUCCESS";
export const TOUR_PROPERTY_CREATE_ACTION = "TOUR_PROPERTY_CREATE_ACTION";
export const TOUR_PROPERTY_CREATE_SUCCESS = "TOUR_PROPERTY_CREATE_SUCCESS";
export const TOUR_PROPERTY_CREATE_FAIL = "TOUR_PROPERTY_CREATE_FAIL";
export const TOUR_PROPERTY_DELETE_ACTION = "TOUR_PROPERTY_DELETE_ACTION";
export const TOUR_PROPERTY_DELETE_SUCCESS = "TOUR_PROPERTY_DELETE_SUCCESS";
export const TOUR_PROPERTY_GET_UPDATE_ACTION = "TOUR_PROPERTY_GET_UPDATE_ACTION";
export const TOUR_PROPERTY_GET_UPDATE_SUCCESS = "TOUR_PROPERTY_GET_UPDATE_SUCCESS";
export const TOUR_PROPERTY_UPDATE_ACTION = "TOUR_PROPERTY_UPDATE_ACTION";
export const TOUR_PROPERTY_UPDATE_SUCCESS = "TOUR_PROPERTY_UPDATE_SUCCESS";
export const TOUR_PROPERTY_FAIL = "TOUR_PROPERTY_FAIL";

export const TOUR_PROPERTY_CREATE_TRANSLATE_ACTION = "TOUR_PROPERTY_CREATE_TRANSLATE_ACTION";
export const TOUR_PROPERTY_CREATE_TRANSLATE_SUCCESS = "TOUR_PROPERTY_CREATE_TRANSLATE_SUCCESS";

export const TOUR_PROPERTY_UPDATE_TRANSLATE_ACTION = "TOUR_PROPERTY_UPDATE_TRANSLATE_ACTION";
export const TOUR_PROPERTY_UPDATE_TRANSLATE_SUCCESS = "TOUR_PROPERTY_UPDATE_TRANSLATE_SUCCESS";

export const TOUR_PROPERTY_DELETE_TRANSLATE_ACTION = "TOUR_PROPERTY_DELETE_TRANSLATE_ACTION";
export const TOUR_PROPERTY_DELETE_TRANSLATE_SUCCESS = "TOUR_PROPERTY_DELETE_TRANSLATE_SUCCESS";